import { MapPin, ArrowUpRight } from "lucide-react";
import { Fade, EASE } from "./Reveal";
import { motion } from "framer-motion";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Revathy+Stores%2C+61+B%2F5%2C+A.V.+Church+Road%2C+Vannandurai%2C+Besant+Nagar%2C+Chennai+600090";
const MAPS_EMBED =
  "https://maps.google.com/maps?q=Revathy%20Stores%2C%2061%20B%2F5%2C%20A.V.%20Church%20Road%2C%20Vannandurai%2C%20Besant%20Nagar%2C%20Chennai%20600090&z=16&output=embed";

const Visit = () => (
  <section id="visit" className="bg-[#0c0c0c] px-5 py-24 md:px-8 md:py-32">
    <div className="mx-auto grid max-w-7xl items-center gap-14 md:grid-cols-2 md:gap-10">
      <Fade>
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-brand-brass">
          Visit Us
        </span>
        <h2 className="mt-4 font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Come by <em className="italic text-brand-brass">the shop.</em>
        </h2>
        <address className="mt-7 not-italic leading-relaxed text-stone-300 sm:text-lg">
          <span className="block">61 B/5, A.V. Church Road</span>
          <span className="block">Vannandurai, Besant Nagar</span>
          <span className="block">Chennai — 600090</span>
        </address>
        <p className="mt-5 max-w-sm text-sm leading-relaxed text-stone-500">
          Walk in and ask — we'll help you pick the right metal for the job.
        </p>
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="visit-directions-btn"
          className="group mt-9 inline-flex items-center gap-3 rounded-full bg-brand-brass px-7 py-4 text-xs font-bold uppercase tracking-[0.16em] text-ink transition-all duration-300 hover:bg-brand-brass-hover hover:shadow-[0_0_36px_rgba(212,175,55,0.4)]"
        >
          <MapPin className="h-4 w-4" />
          Get Directions
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </Fade>

      <Fade delay={0.15} className="relative">
        <div className="absolute -inset-3 rotate-2 rounded-2xl border border-brand-brass/30" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-2xl border border-white/10">
          <iframe
            src={MAPS_EMBED}
            title="Revathy Stores on Google Maps"
            data-testid="visit-map"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            className="map-dark h-[340px] w-full md:h-[460px]"
            style={{ border: 0 }}
          />
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="visit-map-chip"
            className="absolute bottom-5 left-5 rounded-full border border-white/15 bg-black/60 px-4 py-2 backdrop-blur-md transition-colors hover:border-brand-brass"
          >
            <span className="font-mono text-[10px] uppercase tracking-[0.24em] text-brand-brass">
              61 B/5 · A.V. Church Road ↗
            </span>
          </a>
        </div>
      </Fade>
    </div>
  </section>
);

export default Visit;
